var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A0A2A3;}\r\n\t.st1{fill:#0C233F;}\r\n\t.st2{fill:#79BC43;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#266092;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.2,349.7c-63.7,0-120.6-40.5-141.5-100.7C31.6,171,73,85.4,151,58.3c15.9-5.5,32.4-8.3,49.1-8.3 c63.7,0,120.6,40.5,141.5,100.7l0.7,2l0,0c25.7,77.5-15.7,161.8-93.1,188.6C233.4,346.9,216.9,349.7,200.2,349.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.6,132.1c-18.1-33-47.9-56.9-84.1-67.4c-6.2-1.8-12.6-3.2-19-4.1h0l0,0c-69.1-10.2-136,32.8-155.5,100 c-10.5,36.1-6.3,74.1,11.8,107.1c18.1,33,48,56.9,84.1,67.4c6.2,1.8,12.6,3.2,19,4.1c14.1,2.1,28.2,1.9,41.7-0.2 c0.2,0.1,0.3,0.2,0.5,0.3l0.2-0.4c52.5-8.4,97.7-46.4,113.2-99.7C345.9,203.1,341.7,165.1,323.6,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.7,160.2c0,0-1.9,5.2-2.1,10.1c0,0-11.9,1.8-17.6,5.6C172,176,183.8,164.1,191.7,160.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.7,159.7c1.3-0.3,2.3-0.4,3-0.3c-0.2-0.6-0.6-1.5-1.4-2.4c-1-1.3-2.6-2.2-2.6-2.2 C271.8,156.3,271.8,158.3,271.7,159.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261,165.1c1.5-1.1,2.9-1.9,4.2-2.6c-0.2-0.6-0.6-1.3-1.1-2.3c-1-1.8-3.7-3.4-3.7-3.4 C261.5,160,261.3,163.3,261,165.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.6,245.2c-10.1,4.1-34-1.5-34-1.5c24.1-1.4,47.7-18.7,47.7-18.7c0,0,0,0.1-0.1,0.1 c-7.1,10.9-16.8,17.1-16.8,17.1C131.6,243.7,132.6,244.6,133.6,245.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.9,101.3c0,0-5.9-4.6-12.7,2.6C248.5,90.7,252.7,98.2,253.9,101.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.4,165c0,0-0.6-0.4-0.8-0.5c-3.8-2-10.5,3.8-14.9,6.3c-4.4,2.4-10.8,7.6-14,0.5 c-3.1-7.1,4.1-18.2,6.6-25.3c5.5-15.5,5.7-24.6,4.5-29.5c5.1,5.7,6.7,16.8,6.7,16.8s1.9-20.7-8.2-26.1c0.2,0.7,0,3.3-0.2,5.3 c0,0,0,0,0,0c-4.7,0.9-15.1-0.3-18.5-2.1c-12.8,13.7-26.7,32.8-37.2,50.3c-4.5,9.3-9,20.1-10.1,29c0,0-1.4-4-1.8-9.3 c-5.8,2.2-25.5,11.9-29.7,41.6c0,0,12.5-12.9,26.4-18c0,0-8.8,23,8,63.7c0,0,6.8-25,21-31.3c8.6,42.7,33.8,43.4,41.1,72.4 c0,0,7.7-15-1.6-40.6c0,0,3.2,0.9,5.9,4.1c0,0-0.4-7.5-7.4-23.6c-4.6-8.6-6-20.3-6-20.3c-4.1,3.7-5.1,16.2-5.1,16.2 c-12.5-33.9,23-67.5,29.5-72.5c3.2-2.4,5.1-2.5,6.3-1.9C279,167.7,278.8,166.1,277.4,165"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M178.5,94.3c8.9-3.6,18.7-7.4,28-10.5c11.8-4.3,22.3-6.7,30.5-7.9c-0.2-0.1-0.4-0.1-0.6-0.2 c-5.8-1.7-11.6-3-17.5-3.8c-16-2.4-31.9-1.6-47.1,1.8c-0.9,2.8-2.1,8.3-0.1,13.3C172.9,90,175.2,92.4,178.5,94.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.9,183.3c4.6-14.3,10.7-26.4,17.2-36.5c1-2,2.6-5,4.6-8.6c-24.9-2.7-47.5,23.9-56.2,35.8 c-7.2,34.9,0.6,70,19.3,97.9c4.4-7,11.2-17.7,11.2-17.7C94,250.7,84,241.8,84,241.8c5.6-3.5,11.1-7.6,16.4-12 C100.7,213.8,103.1,198.2,107.9,183.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.9,104.4c0.6,0,1.3,0,2,0c12.2-0.7,29.7-0.2,39.7,0.2c4.2-1.9,9.3-4.1,15-6.5c-2.5-2.3-4.4-5-5.6-8.1 c-1.9-4.9-1.9-9.9-1.2-13.9C144.3,81.6,127.2,91.3,112.9,104.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.8,309.5c13.6-8.5,25.7-19.6,35.5-32.8c-4.9-24.4-20.3-50.7-40.9-75c-3.4,8.1-5.2,17-5.4,29.9 c-0.3,15.4,11.5,25.3,12.2,53.6c0,0-3.4-2.4-4.8-3C265.4,282.2,267.9,294.4,268.8,309.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M159.9,130.7c-3.5,1.7-7.4,3.7-11.2,5.8c8.1,5.3,14.6,13.4,19.9,23.1c14.1-10.9,27.2-11.1,27.2-11.1 c1.2-1.5,2.3-2.9,3.4-4.3c-4.4-3-8.8-5.8-13.3-8.5C179.7,133.5,164.9,131.4,159.9,130.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227,112.8c-1.8-0.2-3.6-0.4-5.5-0.6l-1-0.1c-1.1-0.1-2.3-0.2-3.7-0.3c-7.1-0.5-18.5-1.4-32.1-6.1 c-2.8,3.1-5.1,6.3-6.8,9.1c3.5,3.6,10.2,10.6,13.5,14.3c4.4,2.7,8.8,5.5,13.2,8.5C212.9,127.7,220.1,120,227,112.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.1,154.4c13.2-13.6,32.9-28.2,54.9-23.9c1.7-3.1,3.5-6.2,5.1-9c-6.9-4.5-11.1-7.8-23-8.8 c-4.9-0.1-8.9,0-11.8,0.2C93.6,124.7,85,138.7,79.1,154.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324.4,236c4.6-15.7,6-31.5,4.7-46.9c-3.6-16.5-15.9-48-57.6-65.4c1.3,12.4-1.4,24.3-1.4,24.3s7.7,4.5,9.6,13 c0,0,1,0.4,1.8,1.6c2.2,2.6,5,8.7,0.5,20.8c0,0-2.6-5.6-8.2,0.4c-2.4,3.4-4.5,6.5-6.3,9.6c20.3,23.4,36.2,49,43,73.9 C316.4,257.8,321.1,247.3,324.4,236"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M249.3,91.8c3.8,1.4,5.8,3.7,7.2,6.9c7.2,3,11.2,9.1,13.3,16c17.4,6.6,35.7,17.1,49.2,33.9 c-12.3-28.5-34.8-52.4-64.2-66l0,0.2c-0.4,0-27.6-0.6-61.2,15.7c-0.6,0.3-1.2,0.7-1.7,1.1c10.5,3.1,19.3,3.7,25.5,4.1 c1.5,0.1,2.8,0.2,3.9,0.3l0.9,0.1c3.1,0.3,7.1,0.7,11.7,1.4C238.1,97.7,245.1,92.7,249.3,91.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.3,165.2c-5.5-10.7-12.5-19.2-21.4-23.7c-2,1.4-3.7,2.9-5.2,4.4c-14.2,20-24.6,45.8-26.5,76.4 C131.9,201.5,150.8,176.7,162.3,165.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175,102.8l-8.9,13c0,0,6.8,4.7,12.3,11.1c-9.7-2-20.4-3.8-20.4-3.8l-16.9,9.2l7.9-13.2c0,0-5.3-4.6-11.5-8.5 c6.8,0.2,19.6,1.3,19.6,1.3L175,102.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMin);
export default __webpack_public_path__ + "static/media/MIN.05cf0b6416f1d7c0c1a5f89e21b42c17.svg";
export { ForwardRef as ReactComponent };